<template>
  <div class="chat-footer">
    <div class="color-bg-chat">
      <div class="chat-footer-box">
        <input
          v-model="message"
          type="text"
          placeholder="Text Message"
          @keydown.enter="sendMessageLocal"
          @focus="updateGoToBottom(true)"
        />
        {{ alert }}
        <span>
          <a href="#" ref="emoji-action" class="send-button emotes">
            <span>😃</span>
          </a>
          <transition name="fade" leave-active-class="zoomOut">
            <div
              tabindex="0"
              ref="emoji-parent-container"
              class="emoji-parent-container"
              v-show="showEmoji"
              @blur="hideEmoji"
            >
              <ul class="emoji-container">
                <li
                  v-for="(emoji, index) in allEmojis"
                  :key="index"
                  @click.stop.prevent="message += emoji"
                >
                  {{ emoji }}
                </li>
              </ul>
            </div>
          </transition>
        </span>

        <a @click.stop.prevent="sendMessageLocal" href="#" class="send-button">
          <img class="rotate-90" :src="chatArrow" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { nameMixin } from "../../mixins/nameMixin";
import { chatUsernameMixin } from "../../mixins/chatUsernameMixin";
import { mapActions, mapGetters } from "vuex";
import { allEmojis } from "./allEmojis.json";

export default {
  mixins: [nameMixin, chatUsernameMixin],
  data() {
    return {
      allEmojis: allEmojis,
      message: "",
      showEmoji: false,
      chatArrow: require("../../assets/img/chat-arrow-up-icon.png"),
      alert: ""
    };
  },
  props: {
    updateGoToBottom: Function,
    groupUsername: String
  },
  methods: {
    ...mapActions("chat", {
      sendMessage: "sendMessage"
    }),
    sendMessageLocal() {
      if (this.message.trim().length > 0) {
        this.sendMessage({
          message: this.message.trim(),
          username: this.username,
          groupUsername: this.groupUsername
        });
      }
      this.message = "";
      this.showEmoji = false;
      this.updateGoToBottom(true);
    },
    /**
     * Toggle the show and hide emoji screen
     */
    toggleEmoji(event) {
      // Step 0: Prevent default
      event.preventDefault();

      // Step 1: Toggle the emoji screen
      this.showEmoji = !this.showEmoji;

      // Step 2: Focus on the emoji screen
      if (this.showEmoji) {
        setTimeout(() => {
          this.$refs["emoji-parent-container"].focus();
        });
      }
    },
    /**
     * Hide the emoji screen
     */
    hideEmoji() {
      setTimeout(() => {
        this.showEmoji = false;
      }, 100);
    }
  },
  mounted() {
    this.$refs["emoji-action"].addEventListener("click", this.toggleEmoji);
  },
  beforeDestroy() {
    this.$refs["emoji-action"].removeEventListener("click", this.toggleEmoji);
  },
  computed: {
    ...mapGetters("chat", {
      messages: "getMessages"
    })
  }
};
</script>

<style scoped>
.rotate-90 {
  transform: rotate(90deg);
}

.chat-footer {
  width: 99%;
  position: fixed;
  padding: 10px 0px 10px 0px;
  background-color: rgba(255, 255, 255, 0.8);
  bottom: 0px;
  transform: translate3d(0, 0, 0);
}

.chat-footer .chat-footer-box {
  width: stretch;
  margin-right: 10px;
  margin-left: 10px;
  border: 1px solid #ccc;
  border-radius: 50px;
  display: flex;
  align-items: center;
}

.chat-footer .chat-footer-box input {
  border: none;
  background-color: transparent;
  outline: none;
  flex-grow: 1;
  padding: 10px;
  color: black !important;
  font-size: 16px;
}

.chat-footer .chat-footer-box input::placeholder {
  color: gray !important;
}

.chat-footer-box .send-button {
  background-color: #d46d13;
  display: inline-block;
  height: 24px;
  width: 24px;
  border-radius: 50px;
  margin-right: 3px;
  vertical-align: middle;
}

a.send-button.emotes {
  background-color: white;
  font-size: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chat-footer-box .send-button img {
  width: 13px;
  margin-left: 5px;
  margin-top: 3px;
  transform: rotate(90);
}

.color-bg-chat {
  background-color: #fff;
  width: 100%;
  float: left;
}

.emoji-parent-container {
  outline: none;
  width: calc(100vw - 50px);
  max-width: 600px;
  position: absolute;
  overflow: auto;
  z-index: 99999;
  bottom: 50px;
  display: flex;
  right: 20px;
  height: 400px;
  background-color: white;
  overflow: auto;
  box-shadow: 0px 0px 10px gray;
}

.emoji-parent-container ul {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin-top: 10px;
  margin-bottom: 10px;
}

.emoji-parent-container ul li {
  display: flex;
  flex-wrap: wrap;
  width: 52px;
  height: 52px;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}

.emoji-parent-container ul li:hover {
  cursor: pointer;
}

.zoomOut {
  animation: zoomOut 0.5s ease-in-out;
}

@keyframes zoomOut {
  from {
    opacity: 1;
  }

  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
}
</style>
